import {Check} from "src/app/formazione/_Models/Check";
import {TranslateObj} from "../../shared/models/translatedesc";
import {Observable} from "rxjs";
import {ApiPathsService} from "../../api-paths.service";
import {map} from "rxjs/operators";

export class Categorie {
  id: number;
  categoria: string;
  figli: Categorie[];
  foglie?: Check[];
  cat_id?: number;
  id_immagine?: number;
  immagine?: string;
  file?: string;
  UrlImmagine?: string;
  transaltedobjects?: any;
  traduzioni?: TranslateObj[];
  ordine?: number;
  slug?: string | undefined;
  colore?: string;
  fileIcona?: string;
  icona?: string;
  standby?: boolean;
  Cat?: Categorie;
  filtri?: string[];
  values?: { value: string, num: number }[];
}

export function GetCatFiltri(cat: Categorie): string[] {
  return [...cat?.filtri ?? [], ...cat?.values?.map(x => x.value)?.filter(x => cat?.filtri?.includes(x) == false) ?? []];
}
export function GetCatFiltri_asObj(cat: Categorie): {id: string, label:string}[] {
  return GetCatFiltri(cat).map(x=> {return {id: x, label:x}});
}

export function GetCatFull(source, api: ApiPathsService): Observable<Categorie[]> {
  return (source?.type != 'POST' ? api.ClassicGet(`${source.restroute}/list/list`) : api.ClassicPost(`${source.restroute}/list/list`, source.param)).pipe(map((data) => {
    return MapCatTipo(data, source.tipo);
  }))
  // if (source?.type != 'POST') {
  //   this.apiPaths.ClassicGet(`${source.restroute}/list/list`).subscribe(data => {
  //     catFull = [...catFull, ...MapCatTipo(data, source.tipo)];
  //     console.log("CatFull: ", catFull);
  //   })
  // } else
  //   this.apiPaths.ClassicPost(`${source.restroute}/list/list`, source.param).subscribe(data => {
  //     catFull = [...catFull, ...MapCatTipo(data, source.tipo)];
  //     console.log("CatFull: ", catFull);
  //   })
}

export function MapCatTipo(data, tipo) {
  return data?.map(x => {
    var cat = Object.assign(x, {listType: tipo});
    cat.figli = MapCatTipo(cat.figli, tipo);
    return cat;
  }) ?? [];

}
